const name = 'utm';

export const GET_UTM_LIST_REQUEST = `${name}/GET_UTM_LIST_REQUEST`;
export const GET_UTM_LIST_SUCCESS = `${name}/GET_UTM_LIST_SUCCESS`;
export const GET_UTM_LIST_FAILURE = `${name}/GET_UTM_LIST_FAILURE`;

export const GET_UTM_TABLE_CONFIGURATION_REQUEST = `${name}/GET_UTM_TABLE_CONFIGURATION_REQUEST`;
export const GET_UTM_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_UTM_TABLE_CONFIGURATION_SUCCESS`;
export const GET_UTM_TABLE_CONFIGURATION_FAILURE = `${name}/GET_UTM_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_UTM_TABLE_ROW_REQUEST = `${name}/UPDATE_UTM_TABLE_ROW_REQUEST`;
export const UPDATE_UTM_TABLE_ROW_SUCCESS = `${name}/UPDATE_UTM_TABLE_ROW_SUCCESS`;
export const UPDATE_UTM_TABLE_ROW_FAILURE = `${name}/UPDATE_UTM_TABLE_ROW_FAILURE`;

export const CREATE_UTM_TABLE_ROW_REQUEST = `${name}/CREATE_UTM_TABLE_ROW_REQUEST`;
export const CREATE_UTM_TABLE_ROW_SUCCESS = `${name}/CREATE_UTM_TABLE_ROW_SUCCESS`;
export const CREATE_UTM_TABLE_ROW_FAILURE = `${name}/CREATE_UTM_TABLE_ROW_FAILURE`;

export default name;
